"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_FEDERATED_FAILURE = exports.IS_FEDERATED_SUCCESS = exports.IS_FEDERATED = exports.EXCHANGE_CODE_FOR_TOKENS_FAILURE = exports.EXCHANGE_CODE_FOR_TOKENS_SUCCESS = exports.EXCHANGE_CODE_FOR_TOKENS_REQUEST = exports.LOGOUT = exports.SET_PASSWORD = exports.SET_EMAIL = exports.LOGIN_FAILURE = exports.VALIDATE_LOGIN_FAILURE = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = void 0;
exports.LOGIN_REQUEST = '@sok/auth/LOGIN_REQUEST';
exports.LOGIN_SUCCESS = '@sok/auth/LOGIN_SUCCESS';
exports.VALIDATE_LOGIN_FAILURE = '@sok/auth//VALIDATE_LOGIN_FAILURE';
exports.LOGIN_FAILURE = '@sok/auth/LOGIN_FAILURE';
exports.SET_EMAIL = '@sok/auth/SET_EMAIL';
exports.SET_PASSWORD = '@sok/auth/SET_PASSWORD';
exports.LOGOUT = '@sok/auth/LOGOUT';
exports.EXCHANGE_CODE_FOR_TOKENS_REQUEST = '@sok/auth/EXCHANGE_CODE_FOR_TOKENS_REQUEST';
exports.EXCHANGE_CODE_FOR_TOKENS_SUCCESS = '@sok/auth/EXCHANGE_CODE_FOR_TOKENS_SUCCESS';
exports.EXCHANGE_CODE_FOR_TOKENS_FAILURE = '@sok/auth/EXCHANGE_CODE_FOR_TOKENS_FAILURE';
exports.IS_FEDERATED = '@sok/auth/IS_FEDERATED';
exports.IS_FEDERATED_SUCCESS = '@sok/auth/IS_FEDERATED_SUCCESS';
exports.IS_FEDERATED_FAILURE = '@sok/auth/IS_FEDERATED_FAILURE';
//# sourceMappingURL=login.js.map